import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
} from '@/components/_common';
import { useWorkorderImportCilia } from '@/core/domain/workorder/WorkOrdersImports/WorkOrderImports.hooks';
import { WorkOrderImportCiliaForm } from '@/core/domain/workorder/WorkOrdersImports/WorkOrderImports.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Typography,
} from 'antd';
import { ImportModalFormProps } from '..';
import HelpIcon from '@/components/_common/HelpIcon/idex';

const { Title } = Typography;

type Props = ImportModalFormProps;

const ImportCiliaForm: React.FC<Props> = (props) => {
  const [form] = Form.useForm<WorkOrderImportCiliaForm>();
  const requiredRule = useDefaultEmptyFieldError();
  const importCilia = useWorkorderImportCilia();

  function handleClose() {
    form.resetFields();
    props.onClose();
  }

  async function handleSubmit(values: WorkOrderImportCiliaForm) {
    const result = await importCilia.mutateAsync(values);
    props.onImported({ data: result, origin: props.origin });
  }

  return (
    <Form name="import-cilia" form={form} onFinish={handleSubmit}>
      <Row gutter={[16, 16]}>
        <Col span={24} md={12}>
          <FloatingFormItem
            name="companyId"
            label="Empresa"
            rules={[requiredRule]}
          >
            <CompaniesInfiniteSelectField />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12}>
          <FloatingFormItem
            name="BudgetNumber"
            label="Número do orçamento Cilia"
            rules={[requiredRule]}
          >
            <Input />
          </FloatingFormItem>
        </Col>
      </Row>

      <Title level={4} style={{ marginTop: 16, marginBottom: 16 }}>
        Para orçamento de seguradora informe também:
      </Title>

      <Row gutter={[16, 16]}>
        <Col span={24} md={12}>
          <FloatingFormItem name="AccidentNumber" label="Número do sinistro">
            <Input />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12}>
          <FloatingFormItem name="VersionNumber" label="Versão do orçamento">
            <Input />
          </FloatingFormItem>
        </Col>
      </Row>

      <Row>
        <Col>
          <HelpIcon title="Ao ativar esta opção, todas as peças não fornecidas serão tratadas como peças digitadas.">
            <Form.Item
              noStyle
              name="onlyTypedParts"
              initialValue={false}
              valuePropName="checked"
            >
              <Checkbox>Somente peças digitadas</Checkbox>
            </Form.Item>
          </HelpIcon>
        </Col>
      </Row>

      <Divider />

      <Row justify="end" gutter={[16, 16]}>
        <Col>
          <Button onClick={handleClose}>Cancelar</Button>
        </Col>

        <Col>
          <Button
            type="primary"
            htmlType="submit"
            loading={importCilia.isLoading}
          >
            Importar orçamento
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default ImportCiliaForm;
